// This utility function is used by the CustomMTableHeader
// All the exported functions here are just copied from the original common-values files in material-table package

export const elementSize = (props) => (props.options.padding === 'default' ? 'medium' : 'small');
export const baseIconSize = (props) => (elementSize(props) === 'medium' ? 48 : 32);
export const rowActions = (props) => (props.actions || []).filter((a) => a.position === 'row' || typeof a === 'function');
export const actionsColumnWidth = (props) => rowActions(props).length * baseIconSize(props);

export const reducePercentsInCalc = (calc, fullValue) => {
  const captureGroups = calc.match(/(\d*)%/);
  if (captureGroups && captureGroups.length > 1) {
    const percentage = captureGroups[1];
    return calc.replace(/\d*%/, `${fullValue * (percentage / 100)}px`);
  }
  return calc.replace(/\d*%/, `${fullValue}px`);
};
